import React from 'react';

import XDButton from '../buttons/XDButton';
import XDDropdownItemDownload from './XDDropdownItemDownload';

XDDropdownItem.Download = XDDropdownItemDownload;

interface props {
  children: React.ReactNode;
  onClick?: () => void;
  isActive?: boolean;
  className?: string;
}

export default function XDDropdownItem(props: props) {
  const classNames = ['hover:text-teal hover:bg-teal hover:bg-opacity-10 whitespace-nowrap text-left flex gap-1.5'];

  if (!props.isActive) {
    classNames.push('font-normal');
  } else {
    classNames.push('font-bold text-teal-ppt-1 hover:text-teal');
  }

  if (props.className) classNames.push(props.className);

  return (
    <XDButton propagateClick onClick={props.onClick} className={classNames.join(' ')}>
      {props.children}
    </XDButton>
  );
}
